import {
    UPDATE_TRIP_CAR,
    UPDATE_TRIP_DROP,
    RESET_TRIP_POINTS,
    CLEAR_TRIP_POINTS,
    UPDATE_TRIP_PICKUP,
    UPDATE_SELECTED_POINT_TYPE,
} from "../store/types";

const INITIAL_STATE = {
    drop: null,
    pickup: null,
    carType: null,
    selected: 'pickup'
}

export const tripreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_TRIP_PICKUP:
            return {
                ...state,
                pickup: action.payload
            };
        case UPDATE_TRIP_DROP:
            return {
                ...state,
                drop: action.payload
            };
        case UPDATE_TRIP_CAR:
            return {
                ...state,
                carType: action.payload
            };
        case UPDATE_SELECTED_POINT_TYPE:
            return {
                ...state,
                selected: action.payload
            };
        case CLEAR_TRIP_POINTS:
            return {
                ...state,
                drop: {
                    lat: state.pickup.lat,
                    lng: state.pickup.lng,
                    add: ''
                },
                carType: null,
                selected: 'pickup'
            };

        case RESET_TRIP_POINTS: {
            return INITIAL_STATE
        }
        default:
            return state;
    }
};